export function normalizeValue(val) {
  if (val === undefined || val === null) return '';
  if (Array.isArray(val) && val.length === 0) return '';
  return val;
}

export function isDeepEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function buildResolutionResults(conflicts, resolution) {
  return conflicts.map((conflict, index) => {
    const resolved = { ...conflict.localEntity };
    resolved.version = conflict.serverEntity.version;

    const decisions = resolution[index] || {};
    const forceFields = [];

    Object.keys(decisions).forEach((key) => {
      if (decisions[key] === 'server') {
        resolved[key] = conflict.serverEntity[key];
        forceFields.push(key);
      }
    });

    return { resolved, forceFields, base: conflict.serverEntity };
  });
}
